import React, { useState } from 'react';
import ProductManager from './admin/ProductManager';
import UserManager from './admin/UserManager';
import PostManager from './admin/PostManager';
import OrderManager from './admin/OrderManager';
import './AdminDashboard.css';

const AdminDashboard: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'products' | 'users' | 'homepage' | 'orders'>('orders');

  return (
    <div className="admin-dashboard">
      <div className="admin-header">
        <h1>Admin Dashboard</h1>
        <div className="admin-tabs">
          <button
            className={activeTab === 'orders' ? 'active' : ''}
            onClick={() => setActiveTab('orders')}
          >
            Orders
          </button>
          <button
            className={activeTab === 'products' ? 'active' : ''}
            onClick={() => setActiveTab('products')}
          >
            Products
          </button>
          <button
            className={activeTab === 'users' ? 'active' : ''}
            onClick={() => setActiveTab('users')}
          >
            Users
          </button>
          <button
            className={activeTab === 'homepage' ? 'active' : ''}
            onClick={() => setActiveTab('homepage')}
          >
            Homepage
          </button>
        </div>
      </div>

      {activeTab === 'orders' && <OrderManager />}
      {activeTab === 'products' && <ProductManager />}
      {activeTab === 'users' && <UserManager />}
      {activeTab === 'homepage' && <PostManager />}
    </div>
  );
};

export default AdminDashboard;
